import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
const Counter = () => {
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.3,
  });
  const stats = [
    {
      number: 272,
      suffix: "+",
      text: "Hours of hands-on learning in our courses",
    },
    {
      number: 817,
      suffix: "+",
      text: "Students Passed Our Competitions and Got a Job",
    },
    {
      number: 75,
      prefix: "63 /",
      text: "The Ratio of Theory and Practice in Each Course",
    },
    {
      number: 21,
      suffix: "+",
      text: "We teach people from 4 continents and over 40 countries",
    },
  ];
  return (
    <div className="w-full">
      <section
        ref={ref}
        className=" bg-gradient-to-tr from-primaryColor to-secondaryColor py-16 px-6 md:px-12 lg:px-20"
      >
        <div className="max-w-7xl mx-auto  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-left">
          {stats.map((stat, index) => (
            <div key={index} className="space-y-4 ">
              <h3 className="text-5xl font-extrabold text-white heading">
                {stat.prefix && <span>{stat.prefix}</span>}
                {inView ? <CountUp end={stat.number} duration={2.5} /> : 0}
                {stat.suffix && <span>{stat.suffix}</span>}
              </h3>
              <p className="text-white font-medium heading tracking-wide">
                {stat.text}
              </p>
              <div className="w-full h-[1px] bg-gray-900 mt-3"></div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Counter;
